module.exports = __webpack_public_path__ + "img/mind_background_7_th.e4da80f9.png";